module.exports = __webpack_public_path__ + "static/media/research.fe600001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/SI/research.jpg
// module id = 196
// module chunks = 0